module.exports = Swiper;